import React, { Component } from 'react';
import { Button, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { showCookiePreferencesModal } from '../../cookieConsent/actions';
import moment from 'moment';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import 'icheck/skins/minimal/minimal.css';
import cookieConsentService from '../../common/services/cookieConsentService';

class CookiePolicy extends Component {
	render() {
		const { t, franchisor } = this.props;
		const cookieCategories = cookieConsentService.getCookieCategories(franchisor);

		return (<div>
			<h1>{t('FO_CookiePolicy_Page_Heading')}</h1>
			<p style={{ marginBottom: 15 }}>{t('FO_CookiePolicy_Page_Date', { date: moment(franchisor.renewCookieConsentDate).format('L') })}</p>
			<div dangerouslySetInnerHTML={{ __html: t('FO_CookiePolicy_Page_Description') }} />
			<h5>{t('FO_CookiePolicy_TypesOfCookies_Heading')}</h5>
			{Object.entries(cookieCategories).map(([key, category]) => {
				return category.cookies.length > 0 &&
					<CollapsablePanel key={key} collapsed title={category.label} style={{ marginBottom: 15 }}>
						<div>{category.description}</div>
						<Table className='table-expanded'>
							<tbody>
								{category.cookies.map(cookie => {
									return <tr key={cookie.name}>
										<td style={{ background: '#f4f4f4' }}>
											<div style={{ marginBottom: 5, fontWeight: 600 }}>{t('FO_CookiePolicy_Cookie')}</div>
											<div style={{ marginBottom: 5, fontWeight: 600 }}>{t('FO_CookiePolicy_Duration')}</div>
											<div style={{ marginBottom: 5, fontWeight: 600 }}>{t('FO_CookiePolicy_Description')}</div>
										</td>
										<td style={{ background: '#f4f4f4' }}>
											<div style={{ marginBottom: 5 }}>{cookie.name}</div>
											<div style={{ marginBottom: 5 }}>{cookie.duration}</div>
											<div style={{ marginBottom: 5 }}>{cookie.description}</div>
										</td>
									</tr>;
								})}
							</tbody>
						</Table>
					</CollapsablePanel>;
			})}
			<h5>{t('FO_CookiePolicy_ManagePreferences_Heading')}</h5>
			<Button style={{ marginBottom: 15 }} onClick={this.props.showCookiePreferencesModal}>{t('FO_CookiePolicy_ManagePreferences_Button')}</Button>
			<div dangerouslySetInnerHTML={{ __html: t('FO_CookiePolicy_ManagePreferences_Description') }} />
		</div>);
	}
}

const mapStateToProps = state => ({
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps, { showCookiePreferencesModal })(withTranslation()(CookiePolicy));